import getStore from 'src/modules/store';
import {CustomRoleFeatureKeys} from 'src/security/customRoleFeatureKeys';

/** Alineado con stem-web-backend `taskPdfFeatureGates.BLUMAR_CALIDAD_TENANT_ID`. */
export const BLUMAR_CALIDAD_TENANT_ID = '6734b685bc1d916e58496b18';

const LEGACY_BLUMAR_PT_PDF_TENANT_IDS: readonly string[] = [
  '663c2f9ad6da031a0a9389f3',
  '6810df7e8cf1892ddb00865f',
];

const LEGACY_PDF_PT_BUNDLE_KEY = 'taskPdfProcessTemplateLayout';

function hasPtSplitFeature(
  featureKeys: readonly string[],
  key: string,
): boolean {
  if (featureKeys.includes(LEGACY_PDF_PT_BUNDLE_KEY)) {
    return true;
  }
  return featureKeys.includes(key);
}

function legacyBlumarPtPdfEnabled(tenantId: string): boolean {
  return LEGACY_BLUMAR_PT_PDF_TENANT_IDS.includes(tenantId);
}

export function pdfQualityScoreColumnsEnabled(
  _tenantId: string | undefined | null,
  featureKeys: readonly string[],
): boolean {
  return featureKeys.includes(CustomRoleFeatureKeys.taskPdfQualityScoreColumns);
}

export function pdfPhotoDateStampEnabled(
  tenantId: string | undefined | null,
  featureKeys: readonly string[],
): boolean {
  const id = tenantId != null ? String(tenantId) : '';
  if (id === BLUMAR_CALIDAD_TENANT_ID) {
    return hasPtSplitFeature(featureKeys, CustomRoleFeatureKeys.taskPdfPhotoDateStamp);
  }
  if (legacyBlumarPtPdfEnabled(id)) {
    return true;
  }
  return hasPtSplitFeature(featureKeys, CustomRoleFeatureKeys.taskPdfPhotoDateStamp);
}

export function pdfMultiCheckboxSelectedOnlyEnabled(
  tenantId: string | undefined | null,
  featureKeys: readonly string[],
): boolean {
  const id = tenantId != null ? String(tenantId) : '';
  if (id === BLUMAR_CALIDAD_TENANT_ID) {
    return hasPtSplitFeature(featureKeys, CustomRoleFeatureKeys.taskPdfMultiCheckboxSelectedOnly);
  }
  if (legacyBlumarPtPdfEnabled(id)) {
    return true;
  }
  return hasPtSplitFeature(featureKeys, CustomRoleFeatureKeys.taskPdfMultiCheckboxSelectedOnly);
}

export function pdfBulkExportSamePedidoEnabled(
  tenantId: string | undefined | null,
  featureKeys: readonly string[],
): boolean {
  const id = tenantId != null ? String(tenantId) : '';
  if (id === BLUMAR_CALIDAD_TENANT_ID) {
    return hasPtSplitFeature(featureKeys, CustomRoleFeatureKeys.taskPdfBulkExportSamePedido);
  }
  if (legacyBlumarPtPdfEnabled(id)) {
    return true;
  }
  return hasPtSplitFeature(featureKeys, CustomRoleFeatureKeys.taskPdfBulkExportSamePedido);
}

export function pdfModalPreviewColumnFilterEnabled(
  tenantId: string | undefined | null,
  featureKeys: readonly string[],
): boolean {
  const id = tenantId != null ? String(tenantId) : '';
  if (id === BLUMAR_CALIDAD_TENANT_ID) {
    return hasPtSplitFeature(featureKeys, CustomRoleFeatureKeys.taskPdfModalPreviewColumnFilter);
  }
  if (legacyBlumarPtPdfEnabled(id)) {
    return true;
  }
  return hasPtSplitFeature(featureKeys, CustomRoleFeatureKeys.taskPdfModalPreviewColumnFilter);
}

export function getTenantPdfFeatureKeysFromStore(): string[] {
  try {
    const keys = getStore()?.getState()?.auth?.tenantAccessContext?.featureKeys;
    return Array.isArray(keys) ? keys : [];
  } catch {
    return [];
  }
}
